import request from '@/utils/request'

// 快捷回复API

// 分页查询快捷回复列表
export function listQuickReplies(params) {
  return request({
    url: '/api/admin/quick-replies',
    method: 'get',
    params
  })
}

// 获取快捷回复详情
export function getQuickReply(quickReplyId) {
  return request({
    url: `/api/admin/quick-replies/${quickReplyId}`,
    method: 'get'
  })
}

// 创建快捷回复
export function createQuickReply(data) {
  return request({
    url: '/api/admin/quick-replies',
    method: 'post',
    data
  })
}

// 更新快捷回复
export function updateQuickReply(quickReplyId, data) {
  return request({
    url: `/api/admin/quick-replies/${quickReplyId}`,
    method: 'put',
    data
  })
}

// 删除快捷回复
export function deleteQuickReply(quickReplyId) {
  return request({
    url: `/api/admin/quick-replies/${quickReplyId}`,
    method: 'delete'
  })
}

// 批量导入快捷回复
export function batchImportQuickReplies(data) {
  return request({
    url: '/api/admin/quick-replies/batch-import',
    method: 'post',
    data
  })
}

// 启用/禁用快捷回复
export function updateQuickReplyActiveStatus(quickReplyId, isActive) {
  return request({
    url: `/api/admin/quick-replies/${quickReplyId}/active-status`,
    method: 'put',
    params: { isActive }
  })
}

// 获取租户下的所有快捷回复（不分页）
export function getAllQuickReplies(tenantId) {
  return request({
    url: '/api/admin/quick-replies/all',
    method: 'get',
    params: { tenantId }
  })
}

// 获取全局快捷回复
export function getGlobalQuickReplies(tenantId) {
  return request({
    url: '/api/admin/quick-replies/global',
    method: 'get',
    params: { tenantId }
  })
}

// 获取部门快捷回复
export function getDepartmentQuickReplies(departmentId) {
  return request({
    url: `/api/admin/quick-replies/department/${departmentId}`,
    method: 'get'
  })
}
